import React from "react";
import { Redirect, Switch } from "react-router-dom";
import PrivateRoute from "../../../routes/PrivateRoute";

import LandingPage from "../../pages/LandingPage/LandingPage";
import BrandPage from "../../pages/BrandPage/BrandPage";
import SkuValidationPage from "../../pages/SkuValidationPage/SkuValidationPage";
import SkuEditPage from "../../pages/SkuValidationPage/SkuEditPage";
import ProductTypeValidationPage from "../../pages/ProductTypeValidationPage/ProductTypeValidationPage";
import SizePage from "../../pages/SizePage/SizePage";
import ColorPage from "../../pages/ColorPage/ColorPage";
import DeptPage from "../../pages/DeptPage/DeptPage";
import CategoryPage from "../../pages/CategoryPage/CategoryPage";
import SubCategoryPage from "../../pages/SubCategoryPage/SubCategoryPage";
import CounterPage from "../../pages/CounterPage/CounterPage";
import DivisionPage from "../../pages/DivisionPage/DivisionPage";
import TypePage from "../../pages/TypePage/TypePage";
import ArticlePage from "../../pages/ArticlePage/ArticlePage";
import BarcodePage from "../../pages/BarcodePage/BarcodePage";
import GenerateBarcodePage from "../../pages/GenerateBarcodePage/GenerateBarcodePage";
import TransactionCreationPageEcom from "../../pages/TransactionCreationPageEcom/TransactionCreationPageEcom";
import ShippingCreationPage from "../../pages/ShippingCreationPage/ShippingCreationPage";
import MutateCreationPage from "../../pages/ShippingCreationPage/MutateCreationPage";
import ReturnPrincipleCreationPage from "../../pages/ShippingCreationPage/ReturnPrincipleCreationPage";

import TransactionPage from "../../pages/TransactionPage/TransactionPage";
import ShippingPage from "../../pages/ShippingPage/ShippingPage";
import GiftPage from "../../pages/GiftPage/GiftPage";
import DiscountPage from "../../pages/DiscountPage/DiscountPage";
import StockPage from "../../pages/StockPage/StockPage";
import StockOpnamePage from "../../pages/StockOpnamePage/StockOpnamePage";
import StockOpnamePageHistory from "../../pages/StockOpnamePage/StockOpnamePageHistory";
import StockValidationPage from "../../pages/StockValidationPage/StockValidationPage";
import LoginPage from "../../pages/LoginPage/LoginPage";
import WelcomePage from "../../pages/WelcomePage/WelcomePage";
import ReportPage from "../../pages/ReportPage/ReportPage";
import TransactionPageSPG from "../../pages/TransactionPageSPG/TransactionPageSPG";
import DashboardPage from "../../pages/DashboardPage/DashboardPage";
import TransactionHppPage from "../../pages/TransactionHppPage/TransactionHppPage";
import MasterDataPage from "../../pages/MasterDataPage/MasterDataPage";
import ShippingDashboardPage from "../../pages/ShippingDashboardPage/ShippingDashboardPage";
import ReturnPrincipleDashboardPage from "../../pages/ShippingDashboardPage/ReturnPrincipleDashboardPage";
import ShippingDetailPage from "../../pages/ShippingDetailPage/ShippingDetailPage";
import NotificationPage from "../../pages/NotificationPage/NotificationPage";
import StockReportPage from "../../pages/StockReportPage/StockReportPage";
import ChangePasswordPage from "../../pages/ChangePasswordPage/ChangePasswordPage";
import UserListPage from "../../pages/UserListPage/UserListPage";
import PrinciplePage from "../../pages/PrinciplePage/PrinciplePage";
import EcomDashboardPage from "../../pages/EcomDashboardPage/EcomDashboardPage";
import TroubleTransactionPage from "../../pages/TroubleTransactionPage/TroubleTransactionPage";
import AlertWarningPage from "../../pages/AlertWarningPage/AlertWarningPage";
import AlertReportPage from "../../pages/AlertReportPage/AlertReportPage";
import StockNotInOpnamePage from "../../pages/StockPage/StockNotInOpnamePage";
import StockOpnameSummaryPage from "../../pages/StockPage/StockOpnameSummaryPage";
import ProblematicHistoryPage from "../../pages/ProblematicHistoryPage/ProblematicHistoryPage";
function AuthenticatedPage({ history, userData, customerData }) {
  return (
    <Switch>
      <PrivateRoute
        path="/user/brand"
        history={history}
        userData={userData}
        component={BrandPage}
      />
      <PrivateRoute path="/user/size" history={history} component={SizePage} />
      <PrivateRoute
        path="/user/color"
        history={history}
        userData={userData}
        component={ColorPage}
      />
      <PrivateRoute
        path="/user/dept"
        history={history}
        userData={userData}
        component={DeptPage}
      />
      <PrivateRoute
        path="/user/category"
        history={history}
        userData={userData}
        component={CategoryPage}
      />
      <PrivateRoute
        path="/user/category"
        history={history}
        userData={userData}
        component={CategoryPage}
      />
      <PrivateRoute
        path="/user/subcategory"
        history={history}
        userData={userData}
        component={SubCategoryPage}
      />
      <PrivateRoute
        path="/user/counter"
        history={history}
        userData={userData}
        component={CounterPage}
      />
      <PrivateRoute
        path="/user/division"
        history={history}
        userData={userData}
        component={DivisionPage}
      />
      <PrivateRoute
        path="/user/type"
        history={history}
        userData={userData}
        component={TypePage}
      />
      <PrivateRoute
        path="/user/article"
        history={history}
        component={ArticlePage}
        userData={userData}
      />
      <PrivateRoute
        path="/user/barcode"
        history={history}
        component={BarcodePage}
        userData={userData}
      />
      <PrivateRoute
        path="/user/generate-barcode"
        history={history}
        component={
          userData?.roles?.includes("admin") ||
          userData?.roles?.includes("internaladmin")
            ? GenerateBarcodePage
            : () => <Redirect to="/user/welcome" />
        }
        userData={userData}
      />
      <PrivateRoute
        path="/user/create-transaction-ecom"
        history={history}
        userData={userData}
        component={TransactionCreationPageEcom}
      />
      <PrivateRoute
        path="/user/create-shipping"
        history={history}
        userData={userData}
        component={ShippingCreationPage}
      />
      <PrivateRoute
        path="/user/mutate-shipping"
        history={history}
        userData={userData}
        component={MutateCreationPage}
      />
      <PrivateRoute
        path="/user/return-principle"
        history={history}
        userData={userData}
        component={ReturnPrincipleCreationPage}
      />
      <PrivateRoute
        path="/user/transaction"
        history={history}
        userData={userData}
        component={
          userData?.roles?.includes("arearep")
            ? () => <Redirect to="/user/welcome" />
            : TransactionPage
        }
      />
      <PrivateRoute
        path="/user/transaction-spg"
        history={history}
        component={TransactionPageSPG}
      />
      <PrivateRoute
        path="/user/shipping"
        history={history}
        component={ShippingPage}
        userData={userData}
      />
      <PrivateRoute
        path="/user/stock"
        history={history}
        component={StockPage}
        userData={userData}
      />
      <PrivateRoute
        path="/user/stock-not-in-opname"
        history={history}
        component={StockNotInOpnamePage}
        userData={userData}
      />
      <PrivateRoute
        path="/user/opname-summary"
        history={history}
        component={StockOpnameSummaryPage}
        userData={userData}
      />
      <PrivateRoute
        path="/user/problematic-history"
        history={history}
        component={
          userData?.username === "leo"
            ? ProblematicHistoryPage
            : () => <Redirect to="/user/welcome" />
        }
        userData={userData}
      />
      <PrivateRoute
        path="/user/stock-opname"
        history={history}
        component={StockOpnamePage}
        userData={userData}
      />
      <PrivateRoute
        path="/user/stock-opname-history"
        history={history}
        component={StockOpnamePageHistory}
        userData={userData}
      />
      <PrivateRoute path="/user/gift" history={history} component={GiftPage} />
      <PrivateRoute
        path="/user/validate-stock"
        history={history}
        component={StockValidationPage}
      />
      <PrivateRoute
        path="/user/discount"
        history={history}
        userData={userData}
        component={DiscountPage}
      />
      <PrivateRoute
        path="/user/welcome"
        history={history}
        userData={userData}
        component={WelcomePage}
      />
      <PrivateRoute
        path="/user/report"
        history={history}
        userData={userData}
        component={ReportPage}
      />
      <PrivateRoute
        path="/user/dashboard"
        history={history}
        userData={userData}
        component={DashboardPage}
      />
      <PrivateRoute
        path="/user/shipping-dashboard"
        history={history}
        userData={userData}
        component={ShippingDashboardPage}
      />
      <PrivateRoute
        path="/user/return-dashboard"
        history={history}
        userData={userData}
        component={ReturnPrincipleDashboardPage}
      />
      <PrivateRoute
        path="/user/shipping-detail/:id"
        history={history}
        userData={userData}
        component={ShippingDetailPage}
      />
      <PrivateRoute
        path="/user/notification"
        history={history}
        component={NotificationPage}
      />
      <PrivateRoute
        path="/user/hpp-report"
        history={history}
        component={TransactionHppPage}
      />
      <PrivateRoute
        path="/user/stock-report"
        history={history}
        component={StockReportPage}
      />
      <PrivateRoute
        path="/user/alert-warning"
        history={history}
        component={AlertWarningPage}
      />
      <PrivateRoute
        path="/user/alert-report"
        history={history}
        component={AlertReportPage}
      />
      <PrivateRoute
        path="/user/change-password"
        history={history}
        userData={userData}
        component={ChangePasswordPage}
      />
      <PrivateRoute
        path="/user/principle"
        history={history}
        userData={userData}
        component={PrinciplePage}
      />
      <PrivateRoute
        path="/user/ecom-dashboard"
        history={history}
        userData={userData}
        component={EcomDashboardPage}
      />
      <PrivateRoute
        path="/user/sku-validation"
        history={history}
        userData={userData}
        component={SkuValidationPage}
      />
      <PrivateRoute
        path="/user/sku-edit"
        history={history}
        userData={userData}
        component={SkuEditPage}
      />
      <PrivateRoute
        path="/user/pt-validation"
        history={history}
        userData={userData}
        component={ProductTypeValidationPage}
      />
      <PrivateRoute
        path="/user/users"
        history={history}
        userData={userData}
        component={
          userData?.roles?.includes("admin") ||
          userData?.roles?.includes("internaladmin")
            ? UserListPage
            : () => <Redirect to="/user/welcome" />
        }
      />
      <PrivateRoute
        path="/user/troubled-transactions"
        history={history}
        userData={userData}
        component={TroubleTransactionPage}
      />
      <Redirect exact from="/user" to="/user/welcome" />
    </Switch>
  );
}

export default AuthenticatedPage;
